import React from "react";

//UI Material
import { Card, Grid, Stack } from "@mui/material";

//Helpers
import {
  typographyForMainTitles,
  typographyForSubtitles,
  typographyForText,
} from "../../Helpers/typography";

//Helpers
import { selectMonth } from "../../Helpers/date";
import AllProductsGraph from "../Graphs/AllProductsGraph";

export default function AllAccesoriesSummary({ data, orders, dark = false }) {
  //Function to display the finished orders of current month
  const currentInfoPlaceHolder = () => {
    if (data.month === 0) {
      return typographyForText(`Sin productos en ${selectMonth()}`);
    } else {
      return typographyForText(
        `${data.month} en ${selectMonth()}`,
        null,
        "#26D416"
      );
    }
  };

  // ==========> Component <==========
  return (
    <Card
      raised
      sx={{ backgroundColor: dark ? "#2A2D3E" : "#007878", height: "100%" }}
    >
      <Grid
        container
        spacing={1}
        textAlign="center"
        alignItems="center"
        sx={{ padding: "15px", color: "white" }}
      >
        <Grid item xs={8}>
          <Stack justifyContent="center" alignItems="center">
            {typographyForSubtitles("Accesorios y otros", "white")}
            <Stack direction="row" alignItems="center" spacing={1}>
              {typographyForMainTitles(data.total, "white")}
              {typographyForText(`finalizadas`, null, "white")}
            </Stack>
            {currentInfoPlaceHolder()}
          </Stack>
        </Grid>
        <Grid item xs={4}>
          <AllProductsGraph data={orders} />
        </Grid>
      </Grid>
    </Card>
  );
}
